import * as v from 'valibot';

// Paginated response wrapper
export const paginatedSchema = <T extends v.BaseSchema<unknown, unknown, v.BaseIssue<unknown>>>(itemSchema: T) =>
  v.object({
    items: v.nullable(v.array(itemSchema)),
    totalCount: v.number(),
  });

// Option schema for select fields
export const optionSchema = v.object({
  id: v.union([v.string(), v.number()]),
  label: v.string(),
});

export type BaseOption = v.InferOutput<typeof optionSchema>;
export type Option<T = unknown> = BaseOption & T;

export interface Entities<T extends BaseOption> {
  list: T[];
  map: { [key: string]: T };
}

// API Model client -> server
export type FiltersApi<T extends Record<string, unknown> = Record<string, never>> = {
  Skip?: number;
  Take?: number;
  Sorting?: `${Extract<keyof T, string>} asc` | `${Extract<keyof T, string>} desc`;
} & {
  [K in keyof T as `InlineSearch[${string & K}]`]?: T[K];
} & {
  [K in keyof T]?: T[K];
};

// API Model client -> server
export type FiltersUpdateApi<T extends Record<string, unknown> = Record<string, never>> = FiltersApi<T>;

// UI Model
export type Filters<T extends Record<string, unknown> = Record<string, never>> = {
  search?: Partial<Record<keyof T, string>>;
  page?: number;
  limit?: number;
  sorting?: `${Extract<keyof T, string>} asc` | `${Extract<keyof T, string>} desc`;
} & {
  [K in keyof T]?: T[K];
};

export const FILTERS_META_KEYS = ['search', 'page', 'limit', 'sorting'] as const satisfies ReadonlyArray<keyof Filters>;
